import React, { useEffect, useState } from 'react';
import { Button, Form, Row, Col, Modal, Spinner, InputGroup } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { BIEUMAUTUYENSINH_API } from '../../../../../utils/apiUrl';
import { Put } from '../../../../../utils/httpProvider';
import { objectLoaiTuyenSinh } from '../../../../../utils/define';
import Editor from '../../../../../components/editor/Editor';

const schema = yup.object().shape({
    tenBieuMau: yup.string().required('Vui lòng nhập tên biểu mẫu'),
    loaiTuyenSinh: yup.string().required('Vui lòng chọn loại tuyển sinh'),
    moTa: yup.string(),
    duongDanDrive: yup.string().required('Vui lòng nhập đường dẫn Drive')
});

const BieuMauTuyenSinhEdit = ({ isOpen, onClose, dataEdit, activeTab, refreshList }) => {
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        if (dataEdit) {
            setInitialValues({
                tenBieuMau: dataEdit.tenBieuMau || '',
                loaiTuyenSinh: dataEdit.loaiTuyenSinh || '',
                moTa: dataEdit.moTa || '',
                duongDanDrive: dataEdit.duongDanDrive || ''
            });
        }
    }, [dataEdit]);

    const editFunc = useMutation((value) => Put(`${BIEUMAUTUYENSINH_API.UPDATE_ITEM}/${dataEdit?.id}`, null, value, false));

    const handleEdit = (values, { setSubmitting }) => {
        const requestData = {
            id: dataEdit.id,
            tenBieuMau: values.tenBieuMau || '',
            moTa: values.moTa || '',
            duongDanDrive: values.duongDanDrive || '',
            loaiTuyenSinh: values.loaiTuyenSinh || ''
        };

        editFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Cập nhật thành công');
                    queryClient.invalidateQueries(['bieuMauTuyenSinhData']);
                    if (refreshList) {
                        refreshList();
                    }
                    onClose();
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={isOpen} onHide={onClose} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Cập nhật Biểu mẫu tuyển sinh</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!initialValues ? (
                    <div className="text-center p-4">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <Formik
                        validationSchema={schema}
                        onSubmit={handleEdit}
                        initialValues={initialValues}
                        enableReinitialize={true}
                    >
                        {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold">Tên biểu mẫu <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="tenBieuMau"
                                                value={values.tenBieuMau}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {touched.tenBieuMau && !!errors.tenBieuMau && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenBieuMau}</div>}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold">Loại tuyển sinh <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="loaiTuyenSinh"
                                                value={values.loaiTuyenSinh}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Chọn loại tuyển sinh</option>
                                                {objectLoaiTuyenSinh.map((item, index) => (
                                                    <option key={index} value={item.value}>{item.label}</option>
                                                ))}
                                            </Form.Control>
                                            {touched.loaiTuyenSinh && !!errors.loaiTuyenSinh && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.loaiTuyenSinh}</div>}
                                            {values.loaiTuyenSinh && values.loaiTuyenSinh !== activeTab && (
                                                <div className="text-warning mt-1" style={{ fontSize: '13px', fontStyle: 'italic' }}>
                                                    <i className="fas fa-exclamation-triangle mr-1"></i>
                                                    Lưu ý: Bạn đang sửa biểu mẫu từ tab <strong>{objectLoaiTuyenSinh.find(x => x.value === activeTab)?.label}</strong>, nhưng lại chọn loại <strong>{objectLoaiTuyenSinh.find(x => x.value === values.loaiTuyenSinh)?.label}</strong>
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold">Đường dẫn Drive <span className="text-danger">*</span></Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    name="duongDanDrive"
                                                    value={values.duongDanDrive}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Link tới Google Drive hoặc dịch vụ lưu trữ khác"
                                                />
                                                {values.duongDanDrive && (
                                                    <InputGroup.Append>
                                                        <a 
                                                            href={values.duongDanDrive.startsWith('http') ? values.duongDanDrive : `http://${values.duongDanDrive}`} 
                                                            target="_blank" 
                                                            rel="noreferrer" 
                                                            className="btn btn-outline-primary"
                                                            title="Mở link"
                                                        >
                                                            <i className="fas fa-external-link-alt"></i>
                                                        </a>
                                                    </InputGroup.Append>
                                                )}
                                            </InputGroup>
                                            {touched.duongDanDrive && !!errors.duongDanDrive && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.duongDanDrive}</div>}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold">Mô tả</Form.Label>
                                            <Editor
                                                name="moTa"
                                                value={values.moTa}
                                                onChange={(val) => setFieldValue('moTa', val)}
                                            />
                                            {touched.moTa && !!errors.moTa && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.moTa}</div>}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div className="text-right mt-3">
                                    <Button
                                        variant="secondary"
                                        onClick={onClose}
                                        className="mr-2"
                                    >
                                        Hủy
                                    </Button>
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? <><i className="fas fa-spinner fa-spin mr-1"></i> Lưu lại</> : 'Lưu lại'}
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default BieuMauTuyenSinhEdit;
